<template>
  <gral-theme-two/>
</template>
<script>
import gralThemeTwo from '../../../components/faq/general-theme-two'
export default {
  name: 'GeneralThemeTwoView',
  components: {
    gralThemeTwo
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/faq/general-theme-two.view.vue